import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import { createUser, updateUser } from "../../../services/adminServices/AdminServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const INITIAL_FORM_STATE = {
  name: '',
  email: '',
  mobile: '',
  basecoe: '',
};

const INITIAL_ERRORS_STATE = {};

const PracticeMentorModal = ({ open, onClose, title, rowData,getAllUsersData,allCOE}) => {
  const [formValues, setFormValues] = useState(INITIAL_FORM_STATE);
  const [formErrors, setFormErrors] = useState(INITIAL_ERRORS_STATE);
  const [isLoading, setIsLoading] = useState(false);

  
  useEffect(() => {
    if (open) {
      setFormValues(INITIAL_FORM_STATE);
      setFormErrors(INITIAL_ERRORS_STATE);
    }
  }, [open]);
  useEffect(() => {
    if (rowData) {
      setFormValues({
        name: rowData.displayName || '',
        email: rowData.email || '',
        mobile: rowData.mobileNumber || '',
        basecoe: rowData.baseCoe?.id || '',
      });
    }
    setFormErrors(INITIAL_ERRORS_STATE);
  }, [ rowData]);

  const handleInputChange = ({ target: { name, value } }) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const validateFields = () => {
    const errors = {};
    const { name, email, mobile, basecoe } = formValues;

    // const nameRegex = /^[A-Za-z]{2,}$/ ;
    if (!name) {
       errors.name = "Name is required*";
    }
    //  else if (!nameRegex.test(name)) {
    //   errors.name = "Name must contain only letters and be at least 2 characters long*";
    // }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) {
      errors.email = "Email is required*";
    } else if (!emailRegex.test(email)) {
      errors.email = "Enter a valid email address*";
    }

    const mobileRegex = /^[6-9][0-9]{9}$/;
    
    if (!mobile) {
      errors.mobile = "Mobile is required*";
    } else if (!mobileRegex.test(mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9*";
    }

    if (!basecoe) errors.basecoe = "BaseCOE is required*";

    return errors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = validateFields();
    if (Object.keys(errors).length) {
      setFormErrors(errors);
      return;
    }

    const role = title.toLowerCase() === "head" ? "practice_head" : "mentor";

    const requestBody = {
      displayName: formValues.name,
      email: formValues.email,
      mobileNumber: formValues.mobile,
      base_coe_id: formValues.basecoe,
      role: role,
    };
    const editBody = {
      displayName: formValues.name,
      mobileNumber: formValues.mobile,
      base_coe_id: formValues.basecoe,
    };

    setIsLoading(true);

    try {
      if (rowData) {
        const response = await updateUser(rowData.id, editBody);
        toast.success(response?.data?.message);
       
      } else {
        const response = await createUser(requestBody);
        toast.success(response?.data?.message);
      }
      resetFormState();
      onClose();
       getAllUsersData();
    } catch (error) {
      toast.error( error?.response?.data.message||error?.message ||error?.error);
    } finally {
      setIsLoading(false);
    }
  };

  const resetFormState = () => {
    setFormValues(INITIAL_FORM_STATE);
    setFormErrors(INITIAL_ERRORS_STATE);
    setIsLoading(false);
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "45%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            {rowData ? `Edit Practice ${title}` : `Create Practice ${title}`}
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {[{
                label: "Name *",
                name: "name",
                type: "text",
                error: formErrors.name,
              },
              {
                label: "Email *",
                name: "email",
                type: "text",
                error: formErrors.email,
              },
              {
                label: "Mobile *",
                name: "mobile",
                type: "number",
                error: formErrors.mobile,
              },
              {
                label: "Base COE *",
                name: "basecoe",
                type: "select",
                error: formErrors.basecoe,
                component: (
                  <FormControl fullWidth size="small" error={!!formErrors.basecoe}>
                    <InputLabel>Base COE</InputLabel>
                    <Select
                      value={formValues.basecoe}
                      onChange={handleInputChange}
                      name="basecoe"
                      label="Base COE"
                    >{allCOE?.map((data)=><MenuItem value={data?.id}>{data?.name}</MenuItem>
                    )}
                    </Select>
                    {formErrors.basecoe && (
                      <FormHelperText>{formErrors.basecoe}</FormHelperText>
                    )}
                  </FormControl>
                ),
              }].map(({ label, name, type, error, component }) => (
                <Grid item xs={12} key={name}>
                  {component || (
                    <TextField
                      fullWidth
                      size="small"
                      type={type}
                      label={label}
                      name={name}
                      value={formValues[name]}
                      onChange={handleInputChange}
                      error={!!error}
                      helperText={error}
                    />
                  )}
                </Grid>
              ))}
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isLoading}
                  sx={{ marginRight: 2 }}
                >
                  {isLoading ? <CircularProgress size={24} /> : rowData ? "Update" : "Create"}
                </Button>
                <Button variant="outlined" color="secondary" onClick={onClose}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default PracticeMentorModal;
